export default function BouncingChevron() {
	return (
		<div
			aria-hidden="true"
			className="absolute bottom-4 inset-x-0 flex justify-center pointer-events-none animate-bounce-gentle motion-reduce:animate-none"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				strokeWidth={2}
				strokeLinecap="round"
				strokeLinejoin="round"
				className="w-6 h-6 text-gray-400"
			>
				<polyline points="6 9 12 15 18 9" />
			</svg>
		</div>
	)
}
